import {Box, Card, Grid, SectionIntro} from '@primer/react-brand/esm'
import {getPrimerIcon} from '@github-ui/swp-core/lib/utils/icons'
import type {Document} from '@contentful/rich-text-types'
import {renderWithoutParagraphs} from '../../utils'
import baseStyles from '../../styles/base.module.css'
import type {IconLinkItem} from '../../types'
import {clsx} from 'clsx'

export type FlexSuiteOutroResourcesProps = {
  outroResourcesHeading?: Document
  outroResources?: IconLinkItem[]
}

export function FlexSuiteOutroResources({outroResourcesHeading, outroResources}: FlexSuiteOutroResourcesProps) {
  if (!outroResources?.length) return null

  const columnSpan = {xsmall: 12, xlarge: outroResources.length < 3 ? 6 : 4} as const

  const resourceColumns = outroResources.map(resource => {
    const Octicon = getPrimerIcon(resource.fields.icon)
    return (
      <Grid.Column
        key={resource.sys.id}
        span={columnSpan}
        // eslint-disable-next-line @github-ui/github-monorepo/no-global-classname-literals
        className="gridColumn"
      >
        <Box
          className={clsx(baseStyles.gridItem, baseStyles.stackedCardGridItem)}
          padding={{narrow: 24, regular: 40, wide: 64}}
          paddingInlineStart={{narrow: 24, regular: 80, wide: 64}}
          paddingInlineEnd={{narrow: 24, regular: 80, wide: 64}}
          paddingBlockStart={{regular: 80}}
          paddingBlockEnd={{regular: 80}}
          borderWidth="thin"
          borderColor="muted"
          style={{height: '100%'}}
        >
          <Card
            href={resource.fields.href}
            variant="minimal"
            fullWidth
            align="start"
            ctaVariant="arrow"
            ctaText={resource.fields.label}
          >
            {Octicon ? <Card.Icon icon={<Octicon />} color="default" hasBackground /> : null}
            {resource.fields.eyebrow ? <Card.Label>{resource.fields.eyebrow}</Card.Label> : null}
            <Card.Heading>
              {renderWithoutParagraphs(resource.fields.heading)}
              {resource.fields.alt ? <span className="sr-only"> {resource.fields.alt}</span> : null}
            </Card.Heading>
            <Card.Description>{renderWithoutParagraphs(resource.fields.description)}</Card.Description>
          </Card>
        </Box>
      </Grid.Column>
    )
  })

  return (
    <>
      {outroResourcesHeading ? (
        <Box paddingBlockStart={{narrow: 'spacious', regular: 64}} paddingBlockEnd={{narrow: 'none', regular: 64}}>
          <SectionIntro align="center" fullWidth>
            <SectionIntro.Heading size="3">{renderWithoutParagraphs(outroResourcesHeading)}</SectionIntro.Heading>
          </SectionIntro>
        </Box>
      ) : null}
      <Box className={baseStyles.stackedCardGridSection}>
        <Box className={clsx(baseStyles.gridFrameTop, baseStyles.gridFrameBottom)}>
          <Grid columnGap="none" rowGap="none" enableGutters={false}>
            <Grid.Column span={{xsmall: 12, medium: 10, xlarge: 12}} start={{medium: 2}}>
              <Grid columnGap="none" rowGap="none" enableGutters={false} className={baseStyles.narrowStackFrame}>
                {resourceColumns}
              </Grid>
            </Grid.Column>
          </Grid>
        </Box>
      </Box>
    </>
  )
}
